module.exports = __webpack_public_path__ + "img/pantip.1b0be99d.svg";